import PropTypes from 'prop-types';

import { BadgeButton, BadgeIcon } from './styles';

const BadgeItem = ({ name, analyticsOption, icon, alt, onClick }) => (
  <BadgeButton
    type="button"
    data-track="tooltip"
    data-track-destination={`${analyticsOption} Tooltip`}
    title={name || analyticsOption}
    onClick={onClick}
  >
    <span className="filter-icon">
      <BadgeIcon src={icon} alt={alt} />
    </span>
  </BadgeButton>
);

BadgeItem.propTypes = {
  name: PropTypes.string,
  analyticsOption: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

BadgeItem.defaultProps = {
  name: null,
};

export default BadgeItem;
